import { Button } from 'shared/ui/Button';
import { ModalDialog } from 'shared/ui/ModalDialog';

interface LeavePageModalProps {
  isOpen: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => Promise<void> | void;
  onClose: () => void;
  price: string | number;
}

export function ConfirmationModal({ isOpen, onConfirm, onCancel, price, onClose }: LeavePageModalProps) {
  const handleClose = async () => {
    onClose();
  };

  const handleCancelClick = async () => {
    await onCancel();
  };

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={handleClose}
      title={
        <>
          <div>Your weekly budget will be</div>
          <div>{price}</div>
        </>
      }
      className="!w-[456px]"
    >
      <Button
        className="mt-6"
        onClick={async () => {
          await onConfirm();
        }}
      >
        Confirm
      </Button>
      <Button
        className="mt-2"
        onClick={handleCancelClick}
        variant="outline-second"
      >
        Back to edit
      </Button>
    </ModalDialog>
  );
}
